/**
 * FleetManager V3 - Layout Component
 * Main application shell with sidebar and header
 */

import React, { useEffect } from 'react';
import { Sidebar } from './Sidebar.jsx';
import { Header } from './Header.jsx';
import { useAuth } from '../../context/AuthContext.jsx';
import { useOrganizations } from '../../../hooks/useDataHooks.js';
import { applyLanguagePreference } from '../../../i18n/index.js';

/**
 * LanguageSync — applies the server-side language preference once the session is known:
 * localStorage.fm_lang (explicit choice on this browser) > user.language > organization.language > fr.
 * Renders nothing.
 */
function LanguageSync() {
  const { user } = useAuth();
  const { data: organizations = [] } = useOrganizations();
  const orgLanguage = organizations.find((o) => o.code === user?.primary_org_id)?.language
    || organizations[0]?.language
    || null;

  useEffect(() => {
    if (!user) return;
    applyLanguagePreference({ user, organization: orgLanguage ? { language: orgLanguage } : null });
  }, [user, orgLanguage]);

  return null;
}

export function Layout({
  children,
  activeView,
  onNavigate,
  counts = {},
  criticalAlerts = 0
}) {
  return (
    <div className="h-screen bg-gray-50 dark:bg-slate-950 text-gray-900 dark:text-white flex overflow-hidden">
      <LanguageSync />
      <Sidebar
        activeView={activeView}
        onNavigate={onNavigate}
        counts={counts}
      />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header criticalAlerts={criticalAlerts} onNavigate={onNavigate} />
        <main className="flex-1 overflow-y-auto bg-gray-100 dark:bg-slate-900">
          {children}
        </main>
      </div>
    </div>
  );
}

export default Layout;
